import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';
import LineChart from '@/components/charts/LineChart.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import { timeSeriesToLineSeries } from '@/components/charts/timeSeriesAdapter.ts';
import { TimeSeriesDto } from '@/types/stats/TimeSeriesDto.ts';
import { findMetric } from '@/types/stats/metric.utils.ts';
import {
  SIGNUP_SERIES_REGISTRY,
  SignupMetricKey,
  signupMetricLabel,
} from '@/features/dashboard/tours/types/sales/signupSeries.utils.ts';

interface SignupCurveCardProps {
  /** Serie `CURRENT`, `FORECAST`, `BENCHMARK` — pusta linia wypada w adapterze. */
  signups: TimeSeriesDto;
}

/** Zapisy narastająco na tle prognozy i średniej innych wyjazdów firmy. */
const SignupCurveCard = ({ signups }: SignupCurveCardProps) => {
  const series = timeSeriesToLineSeries(signups, SIGNUP_SERIES_REGISTRY);
  const benchmarkTours = findMetric(
    signups.metrics,
    SignupMetricKey.BENCHMARK_TOUR_COUNT,
  );

  return (
    <InfoCard>
      <InfoCardHeader
        title="Zapisy narastająco"
        // Przy zerowej liczbie wyjazdów porównawczych średnia jest szumem,
        // a dopisek obiecywałby porównanie, którego nie ma.
        aside={
          benchmarkTours &&
          benchmarkTours.value > 0 && (
            <span className="text-[13px] text-neutral-400">
              {`${signupMetricLabel(SignupMetricKey.BENCHMARK_TOUR_COUNT)}: ${benchmarkTours.value}`}
            </span>
          )
        }
      />
      <InfoCardBody>
        {series.length === 0 ? (
          <NoItems
            title="Brak zapisów"
            description="Krzywa pojawi się po pierwszej rezerwacji."
          />
        ) : (
          <LineChart series={series} ariaLabel="Zapisy narastająco" />
        )}
      </InfoCardBody>
    </InfoCard>
  );
};

export default SignupCurveCard;
